import {Footer} from '@common/ui/footer/footer';
import {Navbar} from '@common/ui/navigation/navbar/navbar';
import {LinkButton} from '@shadcn/button/button';
import {PageText, useStaticPage} from '@common/static-pages/use-static-page';
import visualUrl from './not-found-visual.png';

export function NotFoundPage() {
  const t = useStaticPage('not_found');
  return (
    <div className="flex min-h-dvh flex-col overflow-x-clip bg-background">
      <Navbar.Root
        variant="site"
        className="sticky top-0 z-10 border-b bg-background"
      />

      <main className="relative isolate flex flex-1 items-center overflow-hidden">
        <img
          src={visualUrl as string}
          alt=""
          className="absolute inset-0 size-full object-cover opacity-90 motion-safe:animate-cd-kenburns"
        />
        <div className="absolute inset-0 bg-linear-to-r from-background via-background/88 to-background/35" />
        <div
          aria-hidden="true"
          className="absolute top-16 right-1/4 size-64 rounded-full bg-primary/25 blur-3xl motion-safe:animate-cd-glow"
        />

        <div className="relative z-10 mx-auto w-full max-w-6xl px-6 py-16 md:px-10 md:py-24">
          <p className="text-sm font-medium tracking-[0.2em] text-primary uppercase">
            <PageText text={t('eyebrow')} />
          </p>
          <h1 className="mt-4 max-w-xl text-4xl font-semibold tracking-tight text-balance md:text-5xl">
            <PageText text={t('title')} />
          </h1>
          <p className="mt-4 max-w-lg text-base leading-7 text-muted-foreground">
            <PageText text={t('description')} />
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <LinkButton to="/" className="h-11 px-5">
              <PageText text={t('home_button')} />
            </LinkButton>
            <LinkButton to="/contact" variant="outline" className="h-11 px-5">
              <PageText text={t('contact_button')} />
            </LinkButton>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
